export default __webpack_public_path__ + "static/media/flayerBB.bc089057.jpg";